const getters = {
  // enums => state.configurationData.enums
  featureAccess: (state) => (state.user && state.user.data && state.user.data.feature_access) || {},
  hasFeature: (state, get) => (key) => Boolean(get.featureAccess[key])
};
export default getters;
